<template>
    <div class="h-dialogContainer">
        <form id="modifyCustomCounterForm">
            <div class='row h-row-around-inputBox'>
                <div class='col-sm-6'>
                    <div class='h-col-inputBox'>
                        <div class="h-inputLit"><span class="h-red-code">* </span>{{$t('Pm.counterNameCH')}}:</div>
                        <div class="e-input-group e-control-wrapper">
                            <input class="e-control e-textbox e-lib e-input" name="counterNameCH" type="text" v-model="counterNameCH">
                        </div>
                    </div>
                    <div class='h-col-inputBox'>
                        <div class="h-inputLit"><span class="h-red-code">* </span>{{$t('Pm.counterUnit')}}:</div>
                        <div class="e-input-group e-con trol-wrapper">
                            <ejs-dropdownlist :dataSource="dataSourceOfUnit" :fields='fieldsOfUnit' v-model="unit"></ejs-dropdownlist>
                        </div>
                    </div>
                </div>
                <div class='col-sm-6'>
                    <div class='h-col-inputBox'>
                        <div class="h-inputLit"><span class="h-red-code">* </span>{{$t('Pm.counterNameEN')}}:</div>
                        <div class="e-input-group e-control-wrapper">
                            <input class="e-control e-textbox e-lib e-input" name="counterNameEN" type="text" v-model="counterNameEN">
                        </div>
                    </div>
                </div>
            </div>
            <div class="row h-row-inputBox h-tableHeight180 h-tableNoPage">
                <div class="col-sm-12 h-col-inputBox  h-tableNoPage">
                    <ejs-grid ref='counterList' :dataSource="counterListData" :allowPaging='false' :allowSorting='false' :recordDoubleClick='counterDoubleClick' :height='130'>
                        <e-columns>
                            <e-column field="counterName" :headerText='$t("Pm.counterName")' textAlign="center" width="33%"  clipMode="EllipsisWithTooltip" :formatter="counterNameFormatter"></e-column>
                        </e-columns>
                    </ejs-grid>
                </div>
            </div>
            <div class="row h-row-inputBox">
                <div class="col-sm-12 h-col-inputBox h-bg-blueTextarea">
                    <div class="h-inputLit"><span class="h-red-code">* </span>{{$t('Pm.counterFormula')}}:</div>
                    <div class="e-float-input e-control-wrapper">
                        <ejs-textbox ref="counterFormula" id="modifyDefault" v-model="counterFormula" name="counterFormula" maxlength="255" :multiline="true" :value="counterFormula" readonly='true' floatLabelType="Never" :placeholder='$t("Pm.doubleClickChoose")' :change='formulaTextChange'></ejs-textbox>
                    </div>
                </div>
            </div>
            <div class="row h-row-inputBox">
                <div class="col-sm-12 h-col-inputBox">
                    <div class="h-borderBox ">
                        <div class="h-buttonBg">
                            <div class="width-200 h-inlineBg">
                                <ejs-button id="modifyButton7" class="e-control e-btn e-lib h-normal e-round h-blue" @click.native.prevent="changeFormula" :disabled='isSwitchStatus' >7</ejs-button>
                                <ejs-button id="modifyButton8" class="e-control e-btn e-lib h-normal e-round h-blue" @click.native.prevent="changeFormula" :disabled='isSwitchStatus' >8</ejs-button>
                                <ejs-button id="modifyButton9" class="e-control e-btn e-lib h-normal e-round h-blue" @click.native.prevent="changeFormula" :disabled='isSwitchStatus' >9</ejs-button>
                                <ejs-button id="modifyButton4" class="e-control e-btn e-lib h-normal e-round h-blue" @click.native.prevent="changeFormula" :disabled='isSwitchStatus' >4</ejs-button>
                                <ejs-button id="modifyButton5" class="e-control e-btn e-lib h-normal e-round h-blue" @click.native.prevent="changeFormula" :disabled='isSwitchStatus' >5</ejs-button>
                                <ejs-button id="modifyButton6" class="e-control e-btn e-lib h-normal e-round h-blue" @click.native.prevent="changeFormula" :disabled='isSwitchStatus' >6</ejs-button>
                                <ejs-button id="modifyButton1" class="e-control e-btn e-lib h-normal e-round h-blue" @click.native.prevent="changeFormula" :disabled='isSwitchStatus' >1</ejs-button>
                                <ejs-button id="modifyButton2" class="e-control e-btn e-lib h-normal e-round h-blue" @click.native.prevent="changeFormula" :disabled='isSwitchStatus' >2</ejs-button>
                                <ejs-button id="modifyButton3" class="e-control e-btn e-lib h-normal e-round h-blue" @click.native.prevent="changeFormula" :disabled='isSwitchStatus' >3</ejs-button>
                            </div>
                            <div class="width-135 h-inlineBg">
                                <ejs-button id="modifyButtonAdd" class="e-control e-btn e-lib h-normal h-orange e-round" @click.native.prevent="changeFormula" :disabled='isSwitchStatus' >+</ejs-button>
                                <ejs-button id="modifyButtonDiv" class="e-control e-btn e-lib h-normal h-orange e-round" @click.native.prevent="changeFormula" :disabled='isSwitchStatus' >/</ejs-button>
                                <ejs-button id="modifyButtonSub" class="e-control e-btn e-lib h-normal h-orange e-round" @click.native.prevent="changeFormula" :disabled='isSwitchStatus' >-</ejs-button>
                                <ejs-button id="modifyButtonLeftBra" class="e-control e-btn e-lib h-normal h-orange e-round" @click.native.prevent="changeFormula" :disabled='isSwitchStatus' >(</ejs-button>
                                <ejs-button id="modifyButtonMul" class="e-control e-btn e-lib h-normal h-orange e-round" @click.native.prevent="changeFormula" :disabled='isSwitchStatus' >*</ejs-button>
                                <ejs-button id="modifyButtonRightBra" class="e-control e-btn e-lib h-normal h-orange e-round" @click.native.prevent="changeFormula" :disabled='isSwitchStatus' >)</ejs-button>
                            </div>
                            <div class="width-65 h-inlineBg">
                                <ejs-button id="modifyButtonSwitch" class="e-control e-btn e-lib h-normal h-green e-round" @click.native.prevent="switchFormula" >{{$t("Pm.switch")}}</ejs-button>
                                <ejs-button id="modifyButtonRevoke" class="e-control e-btn e-lib h-normal h-pink e-round" @click.native.prevent="revokeFormula" :disabled='isSwitchStatus' >{{$t("Pm.revoke")}}</ejs-button>
                                <ejs-button id="modifyButtonClear" class="e-control e-btn e-lib h-normal h-red e-round" @click.native.prevent="clearFormula" :disabled='isSwitchStatus' >{{$t("Pm.clear")}}</ejs-button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="h-clear-rowMg"></div>
        </form>
    </div>
</template>

<script>

    import {FormValidator} from "@syncfusion/ej2-vue-inputs";

    export default {
        name: 'ModifyCustomCounterDialog',

        props: [
            'gnbCounterTreeClickInfo'
        ],

        data() {
            return {
                counterCode: '',
                counterNameCH: '',
                counterNameEN: '',
                unit: '%',
                dataSourceOfUnit: [
                    {text: '%', value: '%'},
                    {text: 'KByte', value: 'KByte'},
                    {text: 'w', value: 'w'},
                    {text: this.$t('Pm.pcs'), value: '个'},
                    {text: this.$t('Pm.times'), value: '次'}
                ],
                fieldsOfUnit: {
                    text: 'text',
                    value: 'value'
                },
                counterListData: [],
                spaceCode: null,
                paramTypeCode: null,
                counterFormula: '',
                formulaBeforeSwitch: '',
                formulaHistory: [],
                isSwitchStatus: false,
                formObjOfModifyCustomCounter: '',
                optionsOfModifyCustomCounterValidation: {
                    customPlacement(inputElement, errorElement) {
                        errorElement.style.position = 'fixed';
                        inputElement.parentElement.parentElement.appendChild(errorElement);
                    },
                    rules: {
                        counterNameCH: {
                            required: [true, `${this.$t('Pm.alertRequired')}`],
                            maxLength: [126, `${this.$t('Pm.alertMaxLength')}126`],
                            regex: [/^([^('"\\<>\s)])([^'"\\<>\s]*)$/, `${this.$t('Pm.notInputSpace')}，${this.$t('Alarm.notInput')}' " \\ < >`],
                        },
                        counterNameEN: {
                            required: [true, `${this.$t('Pm.alertRequired')}`],
                            maxLength: [126, `${this.$t('Pm.alertMaxLength')}126`],
                            regex: [/^([^('"\\<>\s)])([^'"\\<>\s]*)$/, `${this.$t('Pm.notInputSpace')}，${this.$t('Alarm.notInput')}' " \\ < >`],
                        },
                        counterFormula:  {
                            required: [true, `${this.$t('Pm.alertRequired')}`],
                            maxLength: [256, `${this.$t('Pm.alertMaxLength')}256`],
                        }
                    }
                },
            }
        },

        methods: {
            changeFormula(event){
                if (this.isSwitchStatus) {
                    return;
                }
                this.counterFormula = this.counterFormula + event.target.innerText;
            },

            counterDoubleClick(event){
                if (this.isSwitchStatus) {
                    return;
                }
                const { rowData } = event;
                this.counterFormula = this.counterFormula + 'C' + rowData.counterCode;
            },

            switchFormula(){
                const language = localStorage.getItem('locale');

                if(this.counterFormula === undefined || this.counterFormula === ''){
                    return;
                }

                this.isSwitchActionBegin = true;
                let formulaUi = this.counterFormula;
                if(!this.isSwitchStatus){
                    formulaUi = this.counterFormula;
                    this.formulaBeforeSwitch = this.counterFormula;
                    for(const item of this.counterListData){
                        if(language == 'zh'){
                            formulaUi = formulaUi.replace(new RegExp('C' + item.counterCode, 'g'), `[${item.counterNameCH}]`);
                        }else{
                            formulaUi = formulaUi.replace(new RegExp('C' + item.counterCode, 'g'), `[${item.counterNameEN}]`);
                        }
                    }
                }else{
                    formulaUi = this.formulaBeforeSwitch;
                }
                if (this.counterFormula !== formulaUi) {
                    this.isSwitchStatus = !this.isSwitchStatus;
                }
                this.counterFormula = formulaUi;
            },

            revokeFormula(){
                if (this.isSwitchStatus) {
                    return;
                }
                this.isSwitchActionBegin = true;
                const length = this.formulaHistory.length;
                if(length > 1){
                    this.formulaHistory.pop();
                    this.counterFormula = this.formulaHistory[length - 2];
                }else if(length === 1){
                    this.formulaHistory.pop();
                    this.counterFormula = '';
                }
            },

            clearFormula(){
                if (this.isSwitchStatus) {
                    return;
                }
                this.isSwitchActionBegin = true;
                this.counterFormula = '';
                this.formulaHistory = [];
            },

            formulaTextChange(event){
                this.validateOfModifyCustomCounter();
                this.counterFormula = event.value;
                if(event.value !== '' && !this.isSwitchActionBegin){
                    this.formulaHistory.push(event.value);
                }
                this.isSwitchActionBegin = false;
            },

            counterNameFormatter(column,data){
                return (this._i18n.locale === 'zh') ? data['counterNameCH'] : data['counterNameEN'];
            },

            getCounterList(){
                this.getCustomCounterParams();
                this.$loading.showLoadding(this.$t('System.loading'));
                this.$axios.post('/lte/ems/pm/gnb/counter/getCounterList.html', {
                    paramTypeCode: this.paramTypeCode,
                    spaceCode: this.spaceCode
                }).then((response) => {
                    const result = response.data.resultVal;
                    this.counterListData = result;
                    this.$loading.hideLoadding();
                });
            },

            getCustomCounterParams(){
                const clickId = this.gnbCounterTreeClickInfo.id;
                if(clickId == 'root'){
                    this.spaceCode = null;
                    this.paramTypeCode =null;
                }  else if(clickId.split('_')[1] == undefined) {
                    this.spaceCode = null;
                    this.paramTypeCode = clickId.split('_')[0]
                } else {
                    this.spaceCode = clickId.split('_')[0];
                    this.paramTypeCode = clickId.split('_')[1]
                }
            },

            bindValidateOfModifyCustomCounter(){
                this.formObjOfModifyCustomCounter = new FormValidator('#modifyCustomCounterForm', this.optionsOfModifyCustomCounterValidation);
            },

            validateOfModifyCustomCounter() {
                const formStatus = this.formObjOfModifyCustomCounter.validate();
                if (!formStatus) {
                    return false;
                }
                return true;
            },
        }
    }
</script>

<style scoped>
</style>
